module.exports = __webpack_public_path__ + "img/sendouts-inactive.6565b22e.svg";